import React from "react";

function ContactArea() {
  // Switch to a light theme: light panels, dark text, subtle shadows
  const containerStyle = {
    maxWidth: 1330,
    margin: "0 auto",
    padding: "48px 16px",
    boxSizing: "border-box",
  };

  const gridStyle = {
    display: "grid",
    // larger gap for clearer separation
    gridTemplateColumns: "1.1fr 1fr",
    gap: 44,
    alignItems: "start",
  };

  const cardStyle = {
    background: "#ffffff",
    color: "#222222",
    padding: 28,
    borderRadius: 10,
    boxShadow: "0 6px 24px rgba(16,24,40,0.06)",
    border: "1px solid rgba(34,34,34,0.04)",
  };

  const titleStyle = {
    margin: 0,
    marginBottom: 12,
    fontSize: 28,
    letterSpacing: 0.2,
    color: "#1c1121",
    fontFamily: "Oxanium, 'Poppins', sans-serif",
  };

  const infoListStyle = {
    listStyle: "none",
    padding: 0,
    margin: "8px 0 20px 0",
    lineHeight: 1.6,
    fontSize: 14,
    color: "#4a4a4a",
  };

  const inputStyle = {
    width: "100%",
    padding: "12px 14px",
    marginBottom: 12,
    borderRadius: 6,
    border: "1px solid rgba(34,34,34,0.08)",
    background: "#fafafa",
    color: "#222",
    boxSizing: "border-box",
  };

  const textareaStyle = Object.assign({}, inputStyle, {
    minHeight: 120,
    resize: "vertical",
  });

  const buttonStyle = {
    background: "#FF1919",
    color: "#ffffff",
    padding: "12px 26px",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    fontWeight: 700,
    letterSpacing: 0.6,
  };

  const mapWrapperStyle = {
    width: "100%",
    height: 450,
    borderRadius: 10,
    overflow: "hidden",
    boxShadow: "0 6px 24px rgba(16,24,40,0.06)",
    background: "#ffffff",
    border: "1px solid rgba(34,34,34,0.04)",
    display: "flex",
    alignItems: "stretch",
  };

  const responsiveStyle = `@media (max-width: 900px) {
    .contact-grid { grid-template-columns: 1fr; }
    .map-iframe { height: 320px !important; }
    .contact-card { order: 1; }
    .map-card { order: 2; margin-top: 20px; }
  }
  /* Force vertical stacking on tablets & phones */
  @media (max-width: 768px) {
    .contact-grid { grid-template-columns: 1fr !important; gridAutoFlow: row; }
    .contact-card, .map-card { width: 100% !important; margin-bottom: 20px !important; }
    .map-card { margin-top: 0 !important; }
    .map-iframe { height: 280px !important; }
  }
  @media (max-width: 600px) {
    .contact-area { padding: 18px 8px !important; }
    .contact-card { padding: 18px !important; }
    .map-card { padding: 0 !important; min-height: 240px; display: flex; }
    .contact-form-row { grid-template-columns: 1fr !important; }
    .submit-btn { width: 100% !important; padding: 12px 14px !important; }
    .map-iframe { height: 100% !important; flex: 1 1 auto; }
    .section-title.title-style-three { padding-bottom: 8px !important; }
  }
  `;

  return (
    <section className="contact-area" style={{ padding: "40px 0" }}>
      <style>{responsiveStyle}</style>

      <div style={containerStyle} className="container">
        <div style={gridStyle} className="contact-grid">
          <div style={cardStyle} className="contact-card">
            <div className="section-title title-style-three" style={{ paddingBottom: 12 }}>
              <h2 style={titleStyle}>CONTACT US</h2>
            </div>

            <ul style={infoListStyle} aria-label="contact information">
              <li>
                <strong style={{ display: "inline-block", marginRight:"5px" }}>
                  Address:
                </strong>
                <span>
                  2nd Floor, 1-98/5/2/1, Block-B, Eternal Samyuktha, Vittal Rao
                  Nagar, Madhapur, Hyderabad, Telangana, 500081
                </span>
              </li>
              <li>
                <strong style={{ display: "inline-block",  marginRight:"5px"}}>
                  Email:
                </strong>
                <a
                  href="mailto:info@obigingames.com"
                  style={{ color: "#FF1919", textDecoration: "none" }}
                >
                  info@obigin.com
                </a>
              </li>
            </ul>

            <form aria-label="contact form" action="https://formsubmit.co/info@obigingames.com" method="POST">
              <textarea
                name="message"
                id="message"
                placeholder="Write Message..."
                defaultValue={""}
                style={textareaStyle}
                aria-label="message"
              />

              <div className="contact-form-row" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                <input style={inputStyle} type="text" placeholder="Your Name" aria-label="name" />
                <input style={inputStyle} type="email" placeholder="Your Mail" aria-label="email" />
              </div>

              <div style={{ marginTop: 8 }}>
                {/* use theme-like red button */}
                <button type="submit" className="submit-btn" style={buttonStyle} aria-label="submit message">
                  SUBMIT MESSAGE
                </button>
              </div>
            </form>
          </div>

          <div style={Object.assign({}, mapWrapperStyle, { marginLeft: 0 })} className="map-card">
            <iframe
              className="map-iframe"
              title="google map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15225.417062691064!2d78.36498188715821!3d17.442750000000007!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93e0449a5781%3A0xb151f873c46bf854!2sVeniso%20Solutions%20Pvt.%20LTD.!5e0!3m2!1sen!2sin!4v1754429649306!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0, display: "block" }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactArea;
